import DealerPendingRegisterForm from "@/components/Forms/dealer-pending-register-form";

export default function DealerSignupPage() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            <div className="max-w-md w-full bg-card shadow-xl rounded-xl p-6 space-y-4">
                <h1 className="text-2xl font-semibold text-center">Dealer Signup</h1>
                <DealerPendingRegisterForm />
            </div>
        </div>
    );
}
